import Comeback from '@/views/webpc/MemberManagement/MemberComeback/Comeback'

// 定义路由路径数列表
export default [{
  path: '/comeback',
  icon: 'el-icon-user',
  name: '回归会员',
  component: Comeback
}]



// WEBPACK FOOTER //
// ./src/views/webpc/MemberManagement/MemberComeback/routers/index.js